import {get, post} from "../../util/api";
import moment from "moment";

export const FOLLOW_UP = {
    IN_CLINIC: 'In-Clinic-Follow-Up',
    EXPERT_CALL: 'Expert-Call-Follow-Up',
    NO_FOLLOW_UP: 'No-Follow-Up',
    NO_PITCH: 'No-Pitch',
}

export default {
    async findNote(customerId) {
        const note = await get(`/api/sales/${customerId}/note`);
        return {
            followUpType: note.followUpType,
            promisedPrice: note.promisedPrice || '',
            treatmentPlanDeadline: note.treatmentPlanDeadline ? moment(note.treatmentPlanDeadline) : null,
        };
    },
    saveNote(customerId, note) {
        if (!Object.values(FOLLOW_UP).includes(note.followUpType)) {
            throw new Error('Follow-up type is required');
        }

        if (!note.promisedPrice) {
            throw new Error('Promised Price is required');
        }

        const hasAppointment = [FOLLOW_UP.IN_CLINIC, FOLLOW_UP.EXPERT_CALL].includes(note.followUpType);
        if (hasAppointment && !note.treatmentPlanDeadline) {
            throw new Error('Treatment Deadline is required for this follow up type');
        }

        return post(`/api/sales/${customerId}/note`, {
            followUpType: note.followUpType,
            promisedPrice: note.promisedPrice ? note.promisedPrice.toString() : null,
            treatmentPlanDeadline: note.treatmentPlanDeadline ? note.treatmentPlanDeadline.format('YYYY-MM-DD'): null,
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/sales/sdk.js